var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',{staticClass:"px-10 py-4"},[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('submit')}}},[_vm._v(" "+_vm._s(_vm.$t("Save"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }